import { MarkerSidebar } from 'components/minute/sidebar/MarkerSidebar';
import { ScrollVertical } from 'elements/functional/ScrollVertical';
import { useWorldMarker } from 'hooks/marker/useWorldMarker';
import styled from 'styled-components/macro';

interface Props {
    className?: string;
}

export const MarkerPanel = (props: Props) => {
    const worldMarker = useWorldMarker();
    const selectedMarker = worldMarker.getSingleMarkerIfOne();

    return (
        <S_MarkerPanel className={props.className}>
            <ScrollVertical light={true}>
                <MarkerSidebar marker={selectedMarker} />
            </ScrollVertical>
        </S_MarkerPanel>
    );
};

const S_MarkerPanel = styled.div`
    width: 100%;
    height: 100%;
`;
